import { defineKey as T } from 'ha/i18n';

export const MODAL_NAME = 'PaymentRequestsTalkPage';

export const AMOUNT = {
  max: 10 * 1000,
  min: 1,
};

export const Messages = {
  payReqCreated: T('Success! Your payment request has been sent.'),
  payReqFailure: T('Failed to create payment request'),
};
